import client from '../base-api';

const serviceURLV1 = '/report-sick-days/v1';
const serviceURLV2 = '/report-sick-days/v2';

const reportSickDaysService = {

    // V1
    getReportedSickDays(filterData: any) {
        return client.get(`${serviceURLV1}`, {params: filterData});
    },
    postSickDays(data: any) {
        return client.post(`${serviceURLV1}`, data);
    },
    deleteReportedSickDays(id: number) {
        return client.delete(`${serviceURLV1}/${id}`);
    },

    // V2
    getUserListV2(filterData: any) {
        return client.get(`${serviceURLV2}/user-list`, {params: filterData});
    },
    getUserOverviewDataV2(overviewUserId: string) {
        return client.get(`${serviceURLV2}/user-overview/${overviewUserId}`);
    },
    getReportedSickDaysDetailsV2(id: string) {
        return client.get(`${serviceURLV2}/details/${id}`);
    },
    postSickDaysV2(data: any) {
        return client.post(`${serviceURLV2}`, data);
    },
    putSickDaysV2(data: any, id: number) {
        return client.put(`${serviceURLV2}/${id}`, data);
    },
    deleteReportedSickDaysV2(id: number) {
        return client.delete(`${serviceURLV2}/delete/${id}`);
    },
    approveRequestV2(requestId: number, approvedBy: string) {
        return client.put(`${serviceURLV2}/approve/${requestId}/${approvedBy}`);
    },
    declineRequestV2(requestId: number) {
        return client.put(`${serviceURLV2}/decline/${requestId}`);
    },
    getPendingRequestV2(filterData: any) {
        return client.get(`${serviceURLV2}/pending-requests`, {params: filterData});
    },
    countPendingRequestV2() {
        return client.get(`${serviceURLV2}/count-pending-requests`);
    },

}

export default reportSickDaysService;